(function () {
    'use strict';

    function waitForDOM(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }

    const domCache = {};

    function getCachedElement(selector, context = document) {
        if (!domCache[selector]) {
            domCache[selector] = context.querySelector(selector);
        }
        return domCache[selector];
    }

    function getCachedElements(selector, context = document) {
        const cacheKey = `all_${selector}`;
        if (!domCache[cacheKey]) {
            domCache[cacheKey] = context.querySelectorAll(selector);
        }
        return domCache[cacheKey];
    }

    function clearDOMCache() {
        Object.keys(domCache).forEach(key => delete domCache[key]);
    }

    function initCartProperties() {
        const productForm = getCachedElement('#product-form') ||
            getCachedElement('form[action*="cart/add"]');

        if (!productForm) {
            return;
        }

        createHiddenPropertyInputs(productForm);
        setupVariantMonitoring(productForm);
    }

    function createHiddenPropertyInputs(productForm) {
        const oldInputs = productForm.querySelectorAll('input[name*="properties"]');
        oldInputs.forEach(input => input.remove());

        const oldPriceInput = document.createElement('input');
        oldPriceInput.type = 'hidden';
        oldPriceInput.name = 'properties[Old Price]';
        oldPriceInput.id = 'cart-property-old-price';
        productForm.appendChild(oldPriceInput);

        const discountInput = document.createElement('input');
        discountInput.type = 'hidden';
        discountInput.name = 'properties[Discount]';
        discountInput.id = 'cart-property-discount';
        productForm.appendChild(discountInput);
    }

    function setupVariantMonitoring(productForm) {
        const variantContainer = getCachedElement('.product-variants') || productForm;

        variantContainer.addEventListener('click', handleVariantClick);

        const variantSelect = getCachedElement('#product_select');
        if (variantSelect) {
            variantSelect.addEventListener('change', handleSelectChange);
        }

        const initialVariant = getCachedElement('[data-pm-variant-id].available');
        if (initialVariant) {
            updateCartProperties(initialVariant);
        }

        setupAddToCartInterception(productForm);
    }

    function handleVariantClick(event) {
        const variantOption = event.target.closest('[data-pm-variant-id]');
        if (variantOption && variantOption.classList.contains('available')) {
            updateCartProperties(variantOption);
        }
    }

    function handleSelectChange(event) {
        const selectedOption = event.target.options[event.target.selectedIndex];
        if (selectedOption && selectedOption.dataset.pmVariantId) {
            const variantElement = getCachedElement(`[data-pm-variant-id="${selectedOption.dataset.pmVariantId}"]`);
            if (variantElement) {
                updateCartProperties(variantElement);
            }
        }
    }

    function setupAddToCartInterception(productForm) {
        productForm.addEventListener('submit', function (e) {
            const currentVariant = getCachedElement('[data-pm-variant-id].active') ||
                getCachedElement('[data-pm-variant-id].available');

            if (currentVariant) {
                updateCartProperties(currentVariant);
            }

            interceptCartAddRequest();
        }, true);

        const addToCartButtons = getCachedElements('[add-to-cart-button]');
        addToCartButtons.forEach(button => {
            button.addEventListener('click', function (e) {
                const currentVariant = getCachedElement('[data-pm-variant-id].active') ||
                    getCachedElement('[data-pm-variant-id].available');

                if (currentVariant) {
                    updateCartProperties(currentVariant);
                }

                interceptCartAddRequest();
            }, true);
        });
    }

    function updateCartProperties(variantElement) {
        const variantId = variantElement.getAttribute('data-pm-variant-id');
        const comparePrice = variantElement.getAttribute('data-pm-variant-compare-price');
        const currentPrice = variantElement.getAttribute('data-pm-variant-price');

        const variantInput = getCachedElement('#productID');
        if (variantInput && variantId) {
            variantInput.value = variantId;
        }

        clearCartProperties();

        if (comparePrice && currentPrice && comparePrice.trim() && currentPrice.trim()) {
            const comparePriceNum = parseFloat(comparePrice.replace(/[^\d,.-]/g, '').replace(',', '.'));
            const currentPriceNum = parseFloat(currentPrice.replace(/[^\d,.-]/g, '').replace(',', '.'));

            if (!isNaN(comparePriceNum) && !isNaN(currentPriceNum) && comparePriceNum > currentPriceNum) {
                const discount = Math.round(((comparePriceNum - currentPriceNum) / comparePriceNum) * 100);
                setCartProperties(comparePrice, `${discount}% OFF`);
            }
        }
    }

    function setCartProperties(oldPrice, discountText) {
        const oldPriceInput = getCachedElement('#cart-property-old-price');
        const discountInput = getCachedElement('#cart-property-discount');

        if (oldPriceInput && discountInput) {
            const strikethroughPrice = oldPrice.split('').map(char => char + '\u0336').join('');
            oldPriceInput.value = strikethroughPrice;
            discountInput.value = discountText;
        }
    }

    function clearCartProperties() {
        const oldPriceInput = getCachedElement('#cart-property-old-price');
        const discountInput = getCachedElement('#cart-property-discount');

        if (oldPriceInput) oldPriceInput.value = '';
        if (discountInput) discountInput.value = '';
    }

    function interceptCartAddRequest() {
        if (window.cartPropertiesInterceptActive) {
            return;
        }

        window.cartPropertiesInterceptActive = true;
        const originalFetch = window.fetch;

        window.fetch = function (url, options) {
            if (url.includes('cart/add.js') && options && options.body) {
                try {
                    const requestData = JSON.parse(options.body);

                    if (requestData.items && requestData.items.length > 0) {
                        const oldPriceInput = getCachedElement('#cart-property-old-price');
                        const discountInput = getCachedElement('#cart-property-discount');

                        if (oldPriceInput && oldPriceInput.value &&
                            discountInput && discountInput.value) {

                            if (!requestData.items[0].properties) {
                                requestData.items[0].properties = {};
                            }

                            requestData.items[0].properties['Old Price'] = oldPriceInput.value;
                            requestData.items[0].properties['Discount'] = discountInput.value;
                        }
                    }

                    options.body = JSON.stringify(requestData);
                } catch (error) {
                    console.error('Error intercepting cart/add request:', error);
                }
            }

            return originalFetch.call(this, url, options);
        };

        setTimeout(() => {
            window.fetch = originalFetch;
            window.cartPropertiesInterceptActive = false;
        }, 2000);
    }

    waitForDOM(function () {
        initCartProperties();
    });

    if (window.MutationObserver) {
        const observer = new MutationObserver(function (mutations) {
            let shouldReinit = false;

            mutations.forEach(mutation => {
                if (mutation.type === 'childList') {
                    const addedNodes = Array.from(mutation.addedNodes);
                    if (addedNodes.some(node =>
                        node.nodeType === 1 &&
                        (node.matches('[data-pm-variant-id]') ||
                            node.querySelector('[data-pm-variant-id]')))) {
                        shouldReinit = true;
                    }
                }
            });

            if (shouldReinit) {
                clearDOMCache();
                initCartProperties();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

})();
